/* global Hammer */
// eslint-disable-next-line no-unused-vars
const Visualisation = (function () {

    let container;
    let globe;
    let data;
    let win;
    let hammertime;

    function init () {
        if (!Detector.webgl) return Detector.addGetWebGLMessage();

        container = document.getElementById('visualisation');
        win = $(window);
        globe = new Globe(container, {
            imgDir: '/images/',
            colorFn: function(index) {
                const colors = [0xCB2C30, 0x18A3D8, 0x561834, 0x3E3D57, 0xFF9525, 0x409291,0x8B3FC5, 0x7AAA1A, 0xAA641A, 0xAA1A63];
                return new THREE.Color(colors[index % colors.length]);
            }
        });

        data = Data.getData();

        hammertime = new Hammer($('#visualisation')[0], {});
        hammertime.get('pinch').set({ enable: true });

        registerEvents();
        makeTextLabels();
        globe.addDataGroups(Data.makeGlobeData('global'), { format: 'magnitude' });
        globe.updateZoom(1000);
        // globe.animate() called by home.js -> start()
    }


    function update (key = 'global') {
        const keys = key.split('/');
        const group = keys[0];
        const subGroup = keys[1] || '';
        globe.addDataGroups(Data.makeGlobeData(group, subGroup), { format: 'magnitude' });
    }


    function makeTextLabels () {
        globe.clearTextLabels();
        for (const location in data.locationsCoords) {
            if (data.locationsCoords.hasOwnProperty(location)) {
                var loc = data.locationsCoords[location];
                let locationTranslated = Localisation.getTaxonomyTranslation(location);
                globe.createTextLabel(loc[0], loc[1], location, locationTranslated || location);
            }
        }
    }


    function getGlobe () {
        return globe;
    }


    function pinchHandler(event) {
        let value = event.scale * 10;
        if (event.additionalEvent === 'pinchin') {
            value*=-1;
        }
        globe.zoom(value);
    }


    function registerEvents () {
        win.on('resize.makeTextLabels', window.debounce(makeTextLabels, 200));
        hammertime.on('pinch', pinchHandler);
    }

    return { init, getGlobe, update }
})()
